import BaseService from "./BaseService";

export default class ButtonService extends BaseService {

  constructor(self) {
    super(self);
  }

  Acao(parameters) {
    return this.ExecutaFetch("/api/Button/Acao", "POST", parameters);
  }

}